import Process1 from '../../images/Group_751.png';
import Process2 from '../../images/Group_752.png';
import Process3 from '../../images/Group_753.png';
import './HowItWorks.scss';
import './DemandedJobs.scss';
import Header from '../utils/Header';

function HowItWorks() {
    return (
        <div className="how-it-works-wrp wrapper">
            <Header title='How It Works' subTitle='Process Of Jobfi.in'/>
            <div className='process-wrp'>
                <div className='process-container'>
                    <img src={Process1} alt='job-process'/>
                    <div className='process-title'>Post A Job</div>
                    <div className='process-content'>Sign up for Free. Simply post what work you can do at your Part time. Fix your own price and set your time duration for the work posted.</div>
                </div>
                <div className='process-container selected'>
                    <img src={Process2} alt='job-process'/>
                    <div className='process-title'>Get Hired Immediately</div>
                    <div className='process-content'>Your posted Talent will be shown to 1000s of clients who are in need of the same work and you will get hired immediately by the client,who are interested on your profile.</div>
                </div>
                <div className='process-container'>
                    <img src={Process3} alt='job-process'/>
                    <div className='process-title'>Get Paid - Instantly</div>
                    <div className='process-content'>Once you are ready to START the work after all the discussions with the client, the payment will be made in escrow mode. Once the work is completed, you will get paid instantly.</div>
                </div>
            </div>
        </div>
    );
}

export default HowItWorks;